import React from "react"
import { useTranslation } from "react-i18next"
import { EVENT_STATUS } from "src/modules/const"
import { Typography } from "src/UILibrary"

interface Props {
  status: string
}

export const EventStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.event" })

  return (
    <>
      {status === EVENT_STATUS.ARCHIVED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#235496",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#235496",
            fontSize: "13px",
          }}
        >
          {t("archived")}
        </Typography.InputFieldRequired>
      )}
      {status === EVENT_STATUS.RECEIVING && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#FB6F92",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#FB6F92",
            fontSize: "13px",
          }}
        >
          {t("receiving")}
        </Typography.InputFieldRequired>
      )}
      {status === EVENT_STATUS.STARTED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#388E3C",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#388E3C",
            fontSize: "13px",
          }}
        >
          {t("started")}
        </Typography.InputFieldRequired>
      )}
      {status === EVENT_STATUS.CANCELLED && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "#998E8A",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "#998E8A",
            fontSize: "13px",
          }}
        >
          {t("cancelled")}
        </Typography.InputFieldRequired>
      )}
      {status === EVENT_STATUS.DRAFT && (
        <Typography.InputFieldRequired
          sx={{
            p: "0px 10px",
            width: "fit-content",
            color: "gray",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            borderColor: "gray",
            fontSize: "13px",
          }}
        >
          {t("draft")}
        </Typography.InputFieldRequired>
      )}
    </>
  )
}
